<template>
  <div>
    <div class="toggle-button">
      <div
        :class="`toggler  ${toggleModel ? 'bg' : ''}`"
        @click.stop="handleToggleCLick"
      >
        <div :class="`slider ${toggleModel ? 'btns' : ''}`" />
      </div>
      <p>
        {{ labelName }}
        <span v-if="labelInfo && labelInfo.length > 0" :id="id">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.00001 12.0003C8.3682 12.0003 8.66668 11.7018 8.66668 11.3337C8.66668 10.9655 8.3682 10.667 8.00001 10.667C7.63182 10.667 7.33334 10.9655 7.33334 11.3337C7.33334 11.7018 7.63182 12.0003 8.00001 12.0003Z"
              fill="#B3C2CB"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.23738 5.70689C7.91366 5.7211 7.74104 5.85135 7.68129 5.97831C7.5245 6.31145 7.12733 6.45441 6.79419 6.29762C6.46106 6.14083 6.3181 5.74366 6.47489 5.41053C6.82301 4.67086 7.57297 4.40144 8.17892 4.37484C8.7618 4.34926 9.48718 4.53492 9.88849 5.05823C10.1973 5.46093 10.3708 5.9714 10.3007 6.50813C10.2297 7.05237 9.91926 7.54056 9.41556 7.91111C8.74294 8.40594 8.74413 8.65841 8.74431 8.69517C8.74431 8.69571 8.74431 8.6962 8.74431 8.69664C8.74431 9.06483 8.44583 9.36331 8.07764 9.36331C7.70945 9.36331 7.41098 9.06483 7.41098 8.69664C7.41098 8.05884 7.78196 7.45763 8.62545 6.8371C8.88471 6.64637 8.96187 6.46388 8.97862 6.33555C8.99635 6.19971 8.95784 6.03573 8.83044 5.8696C8.82148 5.85791 8.77279 5.80928 8.65086 5.76547C8.53445 5.72363 8.38807 5.70028 8.23738 5.70689Z"
              fill="#B3C2CB"
            />
            <path
              d="M8 15.3337C3.93334 15.3337 0.666672 12.067 0.666672 8.00033C0.666672 3.93366 3.93334 0.666992 8 0.666992C12.0667 0.666992 15.3333 3.93366 15.3333 8.00033C15.3333 12.067 12.0667 15.3337 8 15.3337ZM8 2.00033C4.66667 2.00033 2.00001 4.66699 2.00001 8.00033C2.00001 11.3337 4.66667 14.0003 8 14.0003C11.3333 14.0003 14 11.3337 14 8.00033C14 4.66699 11.3333 2.00033 8 2.00033Z"
              fill="#B3C2CB"
            />
          </svg>
        </span>
        <b-popover
          id="popover-target-2"
          :target="id"
          triggers="click"
          placement="bottom"
          class="info_popup"
        >
          {{ labelInfo }}
        </b-popover>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Label",
  props: {
    id: {
      type: String,
      default: "popover-target-medication-name",
      required: true
    },
    labelName: {
      type: String,
      default: "",
      required: true
    },
    labelInfo: {
      type: String,
      default: null,
      required: false
    },
    toggleModel: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  methods: {
    handleToggleCLick() {
      debugger;
      this.$emit("toggle-click");
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.toggle-button {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  p {
    margin-left: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #474d52;
    margin: 0;
    margin-left: 16px;
    span {
      padding-left: 8px;
    }
  }
}
.toggler {
  position: relative;
  display: inline-block;
  width: 46.5px;
  height: 24px;
  background: #f3f6f9;
  border-radius: 18px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  cursor: pointer;
  @media (max-width: 590px) {
    margin-left: 15px;
  }
}
.slider {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: #b3c2cb;
  box-shadow: 0px 3px 9px #c4c4c4;

  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}
.bg {
  background: rgba(85, 126, 251, 0.1);
}
.btns {
  left: 50%;
  background: var(--theme-color);
  box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
}
</style>
